export default function scrollToElement(target, isScrollHorizontal) {
    window.scrollTo({
        top: isScrollHorizontal !== 1 ? target.offsetTop : 0,
        left: isScrollHorizontal !== 0 && isScrollHorizontal !== undefined ? target.offsetLeft : 0,
        behavior: "smooth"
    });
}
